<script setup lang="ts">
import { TSite } from "@/data/api/kili/sites/types/sites.type";

import SiteAddress from "@/components/site/site-address.vue";

interface IProps {
  site: TSite;
}

interface IEmits {
  (e: "select", siteId: number): void;
}

const props = defineProps<IProps>();
const emits = defineEmits<IEmits>();
</script>

<template>
  <div
    :aria-label="props.site.name"
    class="bg-white flex w-full rounded-md p-4 cursor-pointer"
    :data-site-id="props.site.siteId"
    data-test-id="site-card-link"
    role="button"
    tabindex="0"
    @click="emits('select', props.site.siteId)"
    @keydown.enter="emits('select', props.site.siteId)"
  >
    <div class="flex flex-col gap-2">
      <h3>
        {{ props.site.name }}
      </h3>
      <SiteAddress
        :address="props.site.siteAddressDto"
        show-marker-icon
      />
    </div>
  </div>
</template>
